<template>
      <div class="container">
      <div class="img-container cursorclickicon">
        <img class="img-fluid" @click="modalShow = !modalShow" src="https://storage.googleapis.com/mscharts/portfoliosmith/TradingAnalysis.png" />
      </div>

    <b-modal size="md" v-model="modalShow" hide-footer hide-header body-class="pricingPopUpModel">
      <div class="pricingPopUp">
      <img src="../../assets/img/lockscreens/premiumCard.png">
        <div class="pricingPopUpBtn">
            <button @click="redirecttoplanpage" v-if="!isARGuest"> to view premium reports</button>
            <a class="cursorclickicon" target="_blank" href="https://storage.googleapis.com/mscharts/portfoliosmith/SamplePsiReportGeneric.pdf"> Sample Premium Report </a>
        </div>
    </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "TradingAnalysisBlurred",
  data() {
      return {
        modalShow: false
      }
    },
  computed: {
    isARGuest() {
      return localStorage.getItem('userType') == 3? true:false;
    }
  },

    methods:{

      redirecttoplanpage(){
        this.$router.push('plandetails')
      }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Report/TradingAnalysisBlurred.vue